import type React from 'react';

import classNames from 'classnames';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { PauseIcon } from '../../icons/pause';
import { PlayIcon } from '../../icons/play';
import { Tooltip } from '../tooltip/tooltip';

import styles from './play-button.module.css';

type Props = {
  className?: string;
  isPlaying?: boolean;
  onClick?: () => void;
};

export function PlayButton({ isPlaying = false, onClick, className }: Props) {
  const { t } = useTranslation();

  const pauseButton = useCallback(
    (ref: React.LegacyRef<HTMLButtonElement>, props: Record<string, unknown>) => (
      <button
        type="button"
        name="pause-button"
        className={classNames(className, styles.button)}
        onClickCapture={onClick}
        ref={ref}
        {...props}
      >
        <PauseIcon width="12" height="14" />
      </button>
    ),
    [className, onClick]
  );

  const playButton = useCallback(
    (ref: React.LegacyRef<HTMLButtonElement>, props: Record<string, unknown>) => (
      <button
        type="button"
        name="play-button"
        className={classNames(className, styles.button)}
        onClickCapture={onClick}
        ref={ref}
        {...props}
      >
        <PlayIcon />
      </button>
    ),
    [className, onClick]
  );

  return isPlaying ? (
    <Tooltip tooltip={t('ui.play.button.label.active')} trigger={pauseButton} />
  ) : (
    <Tooltip tooltip={t('ui.play.button.label.inactive')} trigger={playButton} />
  );
}
